<div provide-parent-form>

	<bb-form-element [form]="form" label="{{'NAME' | translate}}">
		<input [(ngModel)]="placement.name" type="text" name="placement_name" />
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'DESCRIPTION' | translate">
		<textarea [(ngModel)]="placement.description" type="text" name="placement_description"></textarea>
	</bb-form-element>

	<bb-form-element [form]="form" label="{{'SCRIPT' | translate}}">
		<textarea [(ngModel)]="placement.src" type="text" name="placement_src" class="placement-script"></textarea>
	</bb-form-element>

	<!-- Use below later? -->
<!-- 	
	<bb-form-element [form]="form" label="{{'SOURCE_JAVASCRIPT_URL' | translate}}">
		<textarea [(ngModel)]="placement.src" type="text" name="placement_src" ></textarea>
	</bb-form-element>

	<div [hidden]="placement.src">
		{{ 'OR' | translate }}
	</div>

	<bb-form-element [form]="form" label="{{'SCRIPT' | translate}}" [hidden]="placement.src">
		<textarea [(ngModel)]="placement.script" type="text" name="placement_script"></textarea>
	</bb-form-element> -->

</div>
